import React, { useContext } from "react";
import { UserContext } from "../../context/UserProvider";
import {
  Container,
  Paper,
  Typography,
  Avatar,
  Grid,
  Box,
  Divider,
  Chip,
} from "@mui/material";
import {
  EmailOutlined,
  PhoneOutlined,
  BusinessOutlined,
  LocationOnOutlined,
  QrCode2Outlined,
} from "@mui/icons-material";
import BackBtn from "../../widgets/BackBtn";

const UserProfile = () => {
  const { user, loading } = useContext(UserContext);

  if (loading) {
    return (
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Typography>Loading...</Typography>
      </Container>
    );
  }

  if (!user) {
    return (
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Typography>No user data available</Typography>
      </Container>
    );
  }

  return (
    <Container>
      <BackBtn />
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
          {/* Header Section */}
          <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
            <Avatar
              sx={{
                width: 80,
                height: 80,
                mr: 2,
                bgcolor: "primary.main",
              }}
            >
              {user.name.charAt(0)}
            </Avatar>
            <Box>
              <Typography variant="h4" component="h1" gutterBottom>
                {user.name}
              </Typography>
              <Chip
                label={user.role}
                color="primary"
                size="small"
                sx={{ fontWeight: "bold" }}
              />
            </Box>
          </Box>

          <Divider sx={{ mb: 3 }} />

          {/* Details Section */}
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <EmailOutlined sx={{ mr: 1, color: "text.secondary" }} />
                <Box>
                  <Typography variant="subtitle2" color="text.secondary">
                    Email
                  </Typography>
                  <Typography variant="body1">{user.email}</Typography>
                </Box>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <PhoneOutlined sx={{ mr: 1, color: "text.secondary" }} />
                <Box>
                  <Typography variant="subtitle2" color="text.secondary">
                    Phone
                  </Typography>
                  <Typography variant="body1">{user.phone}</Typography>
                </Box>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center" }}>
                <BusinessOutlined sx={{ mr: 1, color: "text.secondary" }} />
                <Box>
                  <Typography variant="subtitle2" color="text.secondary">
                    Company
                  </Typography>
                  <Typography variant="body1">{user.company}</Typography>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <LocationOnOutlined sx={{ mr: 1, color: "text.secondary" }} />
                <Box>
                  <Typography variant="subtitle2" color="text.secondary">
                    Address
                  </Typography>
                  <Typography variant="body1">{user.address}</Typography>
                </Box>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center" }}>
                <QrCode2Outlined sx={{ mr: 1, color: "text.secondary" }} />
                <Box>
                  <Typography variant="subtitle2" color="text.secondary">
                    Barcode ID
                  </Typography>
                  <Typography variant="body1">{user.barcodeId}</Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>

          {/* QR Code Section */}
          <Divider sx={{ my: 3 }} />
          <Box sx={{ mt: 3 }}>
            <Typography variant="h6" gutterBottom>
              QR Codes
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <Box>
                  <Typography variant="subtitle2" color="text.secondary">
                    Profile QR
                  </Typography>
                  <img
                    src={user.qrLink}
                    alt="Profile QR"
                    style={{ maxWidth: "150px", marginTop: "8px" }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box>
                  <Typography variant="subtitle2" color="text.secondary">
                    Visitor Registration QR
                  </Typography>
                  <img
                    src={user.visitorRegQr}
                    alt="Visitor QR"
                    style={{ maxWidth: "150px", marginTop: "8px" }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>

          {/* Footer Section */}
          <Divider sx={{ my: 3 }} />
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="caption" color="text.secondary">
              Created: {new Date(user.createdOn).toLocaleDateString()}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Updated: {new Date(user.updatedOn).toLocaleDateString()}
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Container>
  );
};

export default UserProfile;
